const header = document.querySelector(".l-header");
const logo = document.querySelector(".p-anniversary-headerLogo"); // ロゴ要素
const mediaQueryList = window.matchMedia("(min-width: 769px)"); // 769px以上で動作

let scrollHandler = null; // スクロールイベントの管理用

const listener = (event) => {
  if (!logo) return; // p-anniversary-headerLogoが無い場合は処理を中断

  if (event.matches) {
    if (scrollHandler) {
      window.removeEventListener("scroll", scrollHandler);
    }

    scrollHandler = () => {
      const scrollValue =
        window.pageYOffset || document.documentElement.scrollTop; // スクロール値を取得
      const headerHeight = header ? header.clientHeight : 0; // headerが存在しない場合は0

      if (scrollValue < headerHeight) {
        logo.style.top = "0px";
      } else {
        logo.style.top = `${headerHeight}px`;
      }
    };

    window.addEventListener("scroll", scrollHandler);
    scrollHandler();
  } else {
    if (!logo) return; // 追加: モバイル時もp-anniversary-headerLogoが無ければ中断
    const headerHeight = header ? header.clientHeight : 0;
    logo.style.top = `${headerHeight}px`;
  }
};

// 初回ロード時に適用
window.addEventListener("DOMContentLoaded", () => {
  listener(mediaQueryList);
});

// メディアクエリの変更時に適用
mediaQueryList.addEventListener("change", listener);
